import { NET_ID } from ".";

interface StableCoin {
  name: string;
  symbol: string;
  address: string;
  chainId: number;
  decimals: number;
  logoURI?: string;
}
type DexOrMemeConfig = {
  value: string;
  name: string;
  routerAddress: string;
  factoryAddress: string;
  swapRouterAddress?: string;
  quoterV2Address?: string;
  logo: string;
  disabled?: boolean;
};
type DexConfig = {
  dexs: Record<string, DexOrMemeConfig>;
  meme: Record<string, DexOrMemeConfig>;
  stableCoins: StableCoin[];
};

const swapConfig: Record<number, DexConfig> = {
  // Evm Testnet
  11155111: {
    dexs: {
      uniswap: {
        value: "uniswap",
        name: "UniSwap V2",
        routerAddress: "0xeE567Fe1712Faf6149d80dA1E6934E354124CfE3",
        factoryAddress: "0xF62c03E08ada871A0bEb309762E260a7a6a880E6",
        swapRouterAddress: "0xde925D4904E522861bA5967d6e02600652B81E28", // 包装路由合约地址
        logo: "/img/eth/lp/uni.svg",
      },
      uniswapV3: {
        value: "uniswapV3",
        name: "UniSwap V3",
        routerAddress: "0x3bFA4769FB09eefC5a80d6E87c3B9C650f7Ae48E",
        factoryAddress: "0x0227628f3F023bb0B980b67D528571c95c6DaC1c",
        swapRouterAddress: "0x3994E5AE366172b1AA8b5B8BebbFE24462ecA8d9", // 包装路由合约地址
        quoterV2Address: "0xEd1f6473345F45b75F8179591dd5bA1888cf2FB3", // uniswap v3 代币价格预测合约地址
        logo: "/img/eth/lp/uni.svg",
      },
    },
    meme: {},
    stableCoins: [
      {
        name: "USDT Stablecoin",
        symbol: "MUSDT",
        address: "0x810ecC2aa8b798F28633e1586a718cd48083Bae9",
        chainId: 1,
        decimals: 18,
        logoURI:
          "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png",
      },
    ],
  },
  1: {
    dexs: {
      uniswap: {
        value: "uniswap",
        name: "UniSwap V2",
        routerAddress: "0xeE567Fe1712Faf6149d80dA1E6934E354124CfE3",
        factoryAddress: "0xF62c03E08ada871A0bEb309762E260a7a6a880E6",
        swapRouterAddress: "0x3a648108D32a82954B725312c7246ecECC93509E", // 包装路由合约地址
        logo: "/img/eth/lp/uni.svg",
      },
      uniswapV3: {
        value: "uniswapV3",
        name: "UniSwap V3",
        routerAddress: "0x3bFA4769FB09eefC5a80d6E87c3B9C650f7Ae48E",
        factoryAddress: "0x0227628f3F023bb0B980b67D528571c95c6DaC1c",
        swapRouterAddress: "", // 包装路由合约地址
        quoterV2Address: "0xEd1f6473345F45b75F8179591dd5bA1888cf2FB3", // uniswap v3 代币价格预测合约地址
        logo: "/img/eth/lp/uni.svg",
      },
    },
    meme: {
      grafun: {
        value: "GraFun",
        name: "GraFun",
        routerAddress: "",
        factoryAddress: "",
        logo: "/img/bsc/grafun-not-online.svg",
        disabled: true,
      },
    },
    stableCoins: [
      {
        name: "USDT Stablecoin",
        symbol: "USDT",
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        chainId: 1,
        decimals: 6,
        logoURI:
          "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png",
      },
    ],
  },
  // Bsc Testnet
  97: {
    dexs: {
      pancake: {
        value: "pancake",
        name: "PancakeSwap",
        routerAddress: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
        factoryAddress: "0x6725F303b657a9451d8BA641348b6761A6CC7a17",
        swapRouterAddress: "0x43317bE29997149a784D3656Ea092a8BAfC67486",
        logo: "/img/bsc/pancake.svg",
      },
      pancakeV3: {
        value: "pancakeV3",
        name: "PancakeSwapV3",
        routerAddress: "0x1b81D678ffb9C0263b24A97847620C99d213eB14",
        factoryAddress: "0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865",
        swapRouterAddress: "0xC25718b3b65B2514942B4D4CcC494dF91d991cAf",
        quoterV2Address: "0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2", // pancake V3 代币价格预测合约地址
        logo: "/img/bsc/pancake.svg",
      },
    },
    meme: {
      fourmeme: {
        value: "FourMeme",
        name: "FourMeme",
        routerAddress: "0x5c952063c7fc8610FFDB798152D69F0B9550762b",
        factoryAddress: "",
        logo: "/img/bsc/four.svg",
      },
    },
    stableCoins: [
      {
        name: "FAKE USDC",
        symbol: "FUSDC",
        address: "0x4516FC0De3F403343c97ed67c4Ac7E1F85AB44ef",
        chainId: 97,
        decimals: 18,
      }, // FAKE USDC
    ],
  },
  // Bsc Mainnet
  56: {
    dexs: {
      pancake: {
        value: "pancake",
        name: "PancakeSwap V2",
        routerAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        factoryAddress: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
        swapRouterAddress: "0xb87E8C20f1DdDCB7157FA8BC2282100DEb535A29", // "0x182423273BD2404678b5A6A96bfbEC93E95c2aB6",
        logo: "/img/bsc/pancake.svg",
      },
      pancakeV3: {
        value: "pancakeV3",
        name: "PancakeSwap V3",
        routerAddress: "0x13f4EA83D0bd40E75C8222255bc855a974568Dd4",
        factoryAddress: "0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865",
        swapRouterAddress: "0x929e6af2E6094341aaD0a681e7a399AE6636A1aC",
        quoterV2Address: "0xB048Bbc1Ee6b733FFfCFb9e9CeF7375518e25997", // pancake V3 代币价格预测合约地址
        logo: "/img/bsc/pancake.svg",
      },
    },
    meme: {
      fourmeme: {
        value: "FourMeme",
        name: "FourMeme",
        routerAddress: "0x5c952063c7fc8610FFDB798152D69F0B9550762b",
        factoryAddress: "",
        logo: "/img/bsc/four.svg",
      },
    },
    stableCoins: [
      {
        name: "Binance Pegged USDT",
        symbol: "USDT",
        address: "0x55d398326f99059fF775485246999027B3197955",
        chainId: 56,
        decimals: 18,
        logoURI:
          "https://tokens.pancakeswap.finance/images/0x55d398326f99059fF775485246999027B3197955.png",
      },
      {
        "chainId": 56,
        "symbol": "USD1",
        "name": "World Liberty Financial USD",
        "decimals": 18,
        "address": "0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d",
        "logoURI": "https://tokens.pancakeswap.finance/images/0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d.png"
      },
      {
        "chainId": 56,
        "symbol": "FIST",
        "name": "FistToken",
        "decimals": 6,
        "address": "0xC9882dEF23bc42D53895b8361D0b1EDC7570Bc6A",
        "logoURI": "https://assets.coingecko.com/coins/images/25051/thumb/download.png?1696524202"
      },
      // {
      //   name: "Binance Pegged DAI",
      //   symbol: "DAI",
      //   address: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
      //   chainId: 56,
      //   decimals: 18,
      //   logoURI:
      //     "https://tokens.pancakeswap.finance/images/0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3.png",
      // },
      // {
      //   name: "VAI Stablecoin",
      //   symbol: "VAI",
      //   address: "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
      //   chainId: 56,
      //   decimals: 18,
      //   logoURI:
      //     "https://tokens.pancakeswap.finance/images/0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7.png",
      // },
    ],
  },
  8453: {
    dexs: {
      uniswap: {
        value: "uniswap",
        name: "UniSwap V2",
        routerAddress: "0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24",
        factoryAddress: "0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6",
        swapRouterAddress: "0x3a648108D32a82954B725312c7246ecECC93509E",
        logo: "/img/eth/lp/uni.svg",
      },
      uniswapV3: {
        value: "uniswapV3",
        name: "UniSwap V3",
        routerAddress: "",
        factoryAddress: "",
        swapRouterAddress: "",
        quoterV2Address: "0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a", // pancake V3 代币价格预测合约地址
        logo: "/img/base/uni-grey.webp",
        disabled: true,
      },
    },
    meme: {
      virtuals: {
        value: "virtuals",
        name: "virtuals",
        routerAddress: "",
        factoryAddress: "",
        logo: "/img/base/virtuals-grey.webp",
        disabled: true,
      },
    },
    stableCoins: [
      {
        name: "USDC Stablecoin",
        symbol: "USDC",
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        chainId: 8453,
        decimals: 6,
        logoURI: "https://basescan.org/token/images/centre-usdc_28.png",
      },
    ],
  },
};

/**
 * 根据链id返回swap信息
 * @returns
 */
export function getDexs() {
  const index = Number(NET_ID);
  return swapConfig[index].dexs;
}

export function getDefaultDex() {
  const index = Number(NET_ID);
  return Object.keys(swapConfig[index].dexs)[0];
}

export function getMemes() {
  const index = Number(NET_ID);
  return swapConfig[index].meme;
}

export function getStableCoins() {
  const index = Number(NET_ID);
  return swapConfig[index].stableCoins;
}

/**
 * 根据链id和dex值返回对应的routeraddres，方便用来操作合约
 * @param netId
 * @param dexValue
 * @returns
 */
export function getRouterAddress(
  netId: number,
  dexValue: string
): string | undefined {
  const dexConfig = swapConfig[netId];

  if (!dexConfig) {
    return undefined; // 如果没有找到对应的 NET_ID，返回 undefined
  }

  const dex = dexConfig.dexs[dexValue];

  return dex ? dex.routerAddress : undefined; // 如果找到了对应的 value，则返回 routerAddress，否则返回 undefined
}

export function getFactoryAddress(
  netId: number,
  dexValue: string
): string | undefined {
  const dexConfig = swapConfig[netId];

  if (!dexConfig) {
    return undefined; // 如果没有找到对应的 NET_ID，返回 undefined
  }

  const dex = dexConfig.dexs[dexValue];

  return dex ? dex.factoryAddress : undefined; // 如果找到了对应的 value，则返回 routerAddress，否则返回 undefined
}

export function getSwapRouterAddress(
  netId: number,
  dexValue: string
): string | undefined {
  const dexConfig = swapConfig[netId];

  if (!dexConfig) {
    return undefined; // 如果没有找到对应的 NET_ID，返回 undefined
  }

  const dex = dexConfig.dexs[dexValue];

  return dex ? dex.swapRouterAddress : undefined; // 如果找到了对应的 value，则返回 routerAddress，否则返回 undefined
}

export function getQuoterV2Address(
  netId: number,
  dexValue: string
): string | undefined {
  const dexConfig = swapConfig[netId];

  if (!dexConfig) {
    return undefined; // 如果没有找到对应的 NET_ID，返回 undefined
  }

  const dex = dexConfig.dexs[dexValue];

  return dex ? dex.quoterV2Address : undefined; // 如果找到了对应的 value，则返回 routerAddress，否则返回 undefined
}
